import React from 'react';
import '../styles/SearchInput.css';
import { Exit, MagnifyingGlass } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

function SearchInput(props) {
    const value = props.value;
    const onChange = props.onChange;
    const placeholder = props.placeholder;
    const type = props.type;
    const clearInput = props.clearInput;
    const magnifyingGlassFunc = props.magnifyingGlassFunc;
    const disabled = props.disabled;
    const searchLoading = props.searchLoading || false;

    return (
        <div className="search-input-container">
            <div className="search-input-wrapper relative-container">
                <input
                    type={type}
                    value={value}
                    onChange={onChange}
                    className="search-input body-regular colour-primary"
                    placeholder={placeholder}
                    disabled={disabled}
                />
                {
                    value === "" ?
                    <MagnifyingGlass
                        fill={colour.gray04}
                        className="search-input-icon search-magnifying-glass"
                        clickFunc={magnifyingGlassFunc === null ? null : () => magnifyingGlassFunc()}
                    />
                    :
                    <Exit
                        className="search-input-icon search-exit-icon cursor-pointer"
                        fill={colour.gray07}
                        clickFunc={() => clearInput()}
                        size={8}
                    />
                }
                {
                    searchLoading === true &&
                    <div className="search-input-loading-container">
                        <DotLottieReact
                            src="https://lottie.host/7f215b0b-e72e-41ed-b9af-4249c3810a00/afvrLLR4JB.lottie"
                            loop
                            autoplay
                        />
                    </div>
                }
            </div>
        </div>
    )
};

export default SearchInput;